import * as angular from "angular";

import { isSupportedOrNullish } from "../../../../../isSupportedOrNullish";
import { buildEntitySchemaEntries } from "../../../../../entity-schema-state";
import {
	ENTITY_TRANSLATION_KEYS,
	I18NextContext
} from "../../../../../../../services/i18nService";
import {
	getEntityTimeZone,
	getInlineSchemaDisplayValue,
	hasSystemKeyValues,
	mapEntityForForm
} from "../entityFormModel";
import template from "./entity-form-viewer.html";
import "./entity-form-viewer.less";

export function controller(entityManager, $sce) {
	const ctrl = this;

	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;
	ctrl.$onChanges = onChanges;
	ctrl.getInlineSchemaDisplayValue = getDisplayValue;
	ctrl.isSupportedOrNullish = isSupportedOrNullish;

	ctrl.$onInit = () => {
		syncEntity();
	};

	function onChanges(changes) {
		const entityChange = changes.entity;
		if(!entityChange || entityChange.isFirstChange()) {
			return;
		}

		syncEntity(entityChange.currentValue);
	}

	function syncEntity(entity = ctrl.entity) {
		ctrl.isNewEntity = entity === undefined;
		if(ctrl.isNewEntity) {
			ctrl.displayEntity = undefined;
			ctrl.timeZoneName = undefined;
			ctrl.hasSystemKeyValues = false;
			ctrl.inlineSubSchemas = [];
			return;
		}

		ctrl.displayEntity = mapEntityForForm(entity, entityManager);
		ctrl.timeZoneName = getEntityTimeZone(ctrl.displayEntity.TimeZone?.Code)?.name;
		ctrl.hasSystemKeyValues = hasSystemKeyValues(ctrl.entityType, ctrl.displayEntity);

		ctrl.inlineSubSchemas = buildEntitySchemaEntries(
			ctrl.entityType.Schema,
			ctrl.displayEntity,
			$sce
		).filter(entry => !entry.section);
	}

	function getDisplayValue(subSchemaEntry) {
		return getInlineSchemaDisplayValue(ctrl.displayEntity, subSchemaEntry);
	}
}

export default angular.module("vesl.components.entity-form-viewer", [])
	.component("entityFormViewer", {
		controller,
		template,
		bindings: {
			entity: "<",
			entityType: "<"
		}
	})
	.name;
